export const RELEASE_JOB_TYPE = {
  PRODUCT: "Product",
  PRODUCT_MAJOR_UPGRADE: "Product (Major Upgrade)",
  UPDATE: "Update",
  EXTENSION: "Extension",
  COMPONENT: "Component",
  CONFIG_FILE: "Config File",
  LIBRARY: "Library",
  FILE: "File (release notes, icons etc...)",
  FILE_2: "file (release notes, etc...)",
  ENGINE: "Engine",
  LANGUAGE_PACK: "Language Pack",
  PLUGIN: "Plug-in"
};

// Alias for Apr callers that import RELEASE_TYPE
export const RELEASE_TYPE = RELEASE_JOB_TYPE;

export const RELEASE_STATE = {
  NEW: "New",
  DRAFT: "Draft",
  DISCONTINUED: "Discontinued",
  LIVE: "Live",
  PREVIEW: "Preview"
};

export const releaseStateLabel = [RELEASE_STATE.DRAFT, RELEASE_STATE.DISCONTINUED, RELEASE_STATE.LIVE, RELEASE_STATE.PREVIEW]
  .sort((a, b) => a.localeCompare(b));

export const RELEASE_STATE_TOOLTIP = {
  [RELEASE_STATE.DRAFT]: "This release record is in draft mode and can still be edited before finalization.",
  [RELEASE_STATE.NEW]: "This release record is newly created and has not been modified yet."
};

export const RELEASE_CONTENT = {
  State: {
    LIVE_ERROR_MESSAGE_1: (type: string) =>
      `Cannot move release to Live. Missing required ${type}. Both images must be associated with the release to proceed.`
  }
};

export const RELEASE_TOOLTIP_CONTENT = {
  GENERAL_INFO: {
    GARASIGN: {
      message: "All image builds must be Garasign certified before they can be released. Please ensure certification is complete before proceeding..",
      url: "https://wiki.autodesk.com/display/WGMN/General+info"
    },
    EXCEPTION: {
      message: "If the image has not been Garasign certified, an exception must be requested from the Department VPs.",
      url: "https://wiki.autodesk.com/display/WGMN/General+info"
    }
  },
  RELEASE_INFO: {
    DISPLAY_NAME: {
      message: "This release name will appear at customer access points. Updates to this field will be reflected in the manifest.",
      url: "https://wiki.autodesk.com/display/WGMN/Release+Info"
    },
    MILESTONE: {
      message: "You can tag the release with milestone tags to uniquely identify it and control its availability at specific customer access points.",
      url: "https://wiki.autodesk.com/display/WGMN/Release+Info"
    }
  },
  DOCUMENTS: {
    SHORT_DESCRIPTION: {
      message: "This is the short description of the release.",
      url: "https://wiki.autodesk.com/display/WGMN/Release+Documents"
    },
    LONG_DESCRIPTION: {
      message: "This is the long description of the release.",
      url: "https://wiki.autodesk.com/display/WGMN/Release+Documents"
    },
    LOCALIZATION: {
      message:
        "APP allows uploading and updating localization documents. Simply drag and drop or upload a new document. Updates to localization in APP will be reflected in the manifest.",
      url: "https://wiki.autodesk.com/display/WGMN/Release+Documents"
    },
    RELEASE_NOTES: {
      message:
        "APP allowsUpload and update release notes documents by simply dragging and dropping or uploading a new document. Updates to localization in APP will be reflected in the manifest.",
      url: "https://wiki.autodesk.com/display/WGMN/Release+Documents"
    }
  },
  TARGETING: {
    CONFIGURED_TARGETS: {
      message: "List of releases that will be updated by this current release.",
      url: "https://wiki.autodesk.com/display/WGMN/Release+Targets"
    },
    SEARCH_PLC: {
      message: "Select the PLC for which you want to find Products and Components.",
      url: "https://wiki.autodesk.com/display/WGMN/Release+Targets"
    },
    RELEASE_YEAR: {
      message: "Filter Products and Components by release year.",
      url: "https://wiki.autodesk.com/display/WGMN/Release+Targets"
    },
    BUILD_NUMBER: {
      message: "Choose the build number to further refine Products and Components.",
      url: "https://wiki.autodesk.com/display/WGMN/Release+Targets"
    },
    TARGETABLE: {
      message: "Select the Products and Components that will be updated by the current release.",
      url: "https://wiki.autodesk.com/display/WGMN/Release+Targets"
    },
    SHOW_COMPONENTS: {
      message: "Toggle to include Components (COM) in the Products and Components list.",
      url: "https://wiki.autodesk.com/display/WGMN/Release+Targets"
    }
  },
  RELEASE_IMAGES: {
    DOWNLOAD_FILE: {
      message: "This is the primary download file that will be delivered to customers.",
      url: "https://wiki.autodesk.com/display/WGMN/Release+Documents"
    },
    INSTALL_FILE: {
      message: "This is the primary install file that will be delivered to customers.",
      url: "https://wiki.autodesk.com/display/WGMN/Release+Documents"
    },
    FILE_NAME: {
      message: "File name of the installer."
    },
    FILE_SIZE: {
      message: "Size of the install file to ensure correct transfer and validation.",
      url: "https://wiki.autodesk.com/display/WGMN/Release+Documents"
    },
    CHECKSUM: {
      message: "Checksum value of the install file helps verify the file's integrity after transfer.",
      url: "https://wiki.autodesk.com/display/WGMN/Release+Documents"
    }
  }
};

export const milestoneLabel: any = {
  ALPHA: "Alpha",
  BETA: "Beta",
  RTM: "RTM (General Release)",
  "PRE-RELEASE": "Pre-Release",
  OTHER: "Other",
  SLIPSTREAM: "Slipstream",
  "START STOP": "Start Stop"
};

export const GARASIGN_STATE = {
  NOT_APPLICABLE: "Not applicable",
  NOT_REVIEWED: "Not reviewed",
  REVIEWED: "Reviewed",
  NOT_EXEMPTED: "Not exempted",
  EXEMPTED: "Exempted"
};

export const RADIO_VALUES = {
  YES: "YES",
  NO: "NO",
  NOT_APPLICABLE: "Not applicable"
};

export const IMAGE_TYPE = {
  DI: "DI",
  IN: "IN",
  DB: "DB",
  DLM: "DLM",
  DS: "DS",
  DF: "DF"
};

export const CTA = {
  STATE_UPDATE_ACTION: "STATE_UPDATE_ACTION"
};

export const READINESS_CHECK_URL = "https://autodesk.atlassian.net/wiki/x/9jTVKw";

export const SUBMIT_RELEASE_STEP_NUMBER = {
  GENERALINFO: 0,
  RELEASEINFO: 1,
  DOCUMENTS: 2,
  TARGETING: 3,
  RELEASEIMAGES: 4,
  REVIEW: 5
};
